import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const sendEmptyMessageFromAgent = async (roomId: string): Promise<AxiosResponse> =>
  AxiosInstance.post('chat.postMessage', {
    roomId,
    text: '',
  });
